import { render, staticRenderFns } from "./HistoriaView.vue?vue&type=template&id=524d35dc&scoped=true"
import script from "./HistoriaView.vue?vue&type=script&lang=js"
export * from "./HistoriaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524d35dc",
  null
  
)

export default component.exports